import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import colors from "../constants/colors";
const ErrorPage = ({ message = "An unexpected error occurred" }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
        gap: 3,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 64, color: colors.sienna[700] }} />
      <Typography variant="h4" component="h1" gutterBottom>
        Oops! Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {message}
      </Typography>
    </Box>
  );
};

export default ErrorPage;
